export default {
  title: 'You are going to duplicate the {{entityTitle}}',
  subTitle:
    'Please provide the details below. You may keep the default or change it as needed. Remember to update later any specific details of the duplicated {{entityTitle}} as necessary.',
  nameLabel: '{{entityTitle}} name',
  dueDateTitle: 'Due Date',
  periodTitle: 'Period',
  startingAtPlaceholder: 'Starting date',
  dueDatePlaceholder: 'Due date',
  projectNotes: `The following relationships linked to the project will be duplicated: TODOs, PROJECT USERs, and PRACTICE GROUPs.
      For TODOs, new records will be created, their names will remain the same, and their due dates will be set to match the project's due date.
      Please review these items after duplication.`,
  duplicateButton: 'Duplicate',
  cancelButton: 'Cancel',
};
